import { render, staticRenderFns } from "./UserRegBase.vue?vue&type=template&id=0804b8ee"
import script from "./UserRegBase.vue?vue&type=script&lang=js"
export * from "./UserRegBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports